import React from 'react'
import { useStore, useViews } from 'state'
import styled from 'styled-components'
import { PhoneContainer } from '../../Kit/Container'
import { Checkout } from '../../GJKit/Checkout'
import { TopNavBar } from '../TopNavBar'
import { Products } from '../../Products/Products'
import { OrderStatus } from '../../Checkout/OrderStatus'
import { selectActiveCallCard } from '../../../reducers/uiSlice'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { useProducts } from 'ui'

export const ViewContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: ${({ isCheckoutForm }) => (isCheckoutForm ? ' 2rem 0' : '2rem')};
  gap: 0.5rem;
  height: 100%;
  border-radius: 1rem;
  background-color: white;
`

const DesktopCardContainer = styled(PhoneContainer)`
  display: flex;
  flex-direction: column;
  overflow: initial;
`

const DesktopCardBox = styled.section`
  display: flex;
  flex-direction: column;
`

export const DesktopCard = () => {
  const activeCallCard = useSelector(selectActiveCallCard)
  const { state, send } = useViews()
  const { event } = useStore()
  const [searchParams] = useSearchParams()
  const isIframe = searchParams.get('iframe') === 'true'
  const { products, getProductsBySearchTerm } = useProducts({
    callId: event?.eventId,
  })

  const goBack = () => {
    send({
      type: 'GO_BACK',
    })
  }

  return (
    <DesktopCardBox>
      <DesktopCardContainer data-test="desktop-cart-container">
        <TopNavBar isDesktop isIframe={isIframe} />
        {state.matches('primary.showingProducts') === true ||
        state.matches('primary.showingPDP') === true ||
        state.matches('primary.showingCart') === true ? (
          <Products products={products} getProductsBySearchTerm={getProductsBySearchTerm} />
        ) : state.matches('primary.showingOrder') === true ? (
          <Checkout onGoBack={goBack} />
        ) : state.matches('primary.showingOrderStatus') === true ? (
          <OrderStatus activeCallCard={activeCallCard} />
        ) : null}
      </DesktopCardContainer>
    </DesktopCardBox>
  )
}
